/* Utils */
import {
  generateSelectEntityById,
} from '../utils/generators/selectorGenerators';

export const selectAllRowAds = (state) => state.rowAds;
export const selectRowAdById = generateSelectEntityById(selectAllRowAds);
